<script>
import { commands } from '../../js/lib/functions.js'
import { navigate } from '@trullock/page-manager'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { getEmailCampaignView } from '../../js/readModel.js';
import { pasteHandler } from '../../js/utils/paste.js';

export const pageName = 'admin-email-campaigns-edit';
export const pageRoute = '/admin/email-campaigns/{campaignId}/edit';
export const title = 'Edit campaign'
export const requireAdmin = true;

export default {
	data() {
		return {
			name: '',
			audience: 'all',
			exclusions: '',
			subject: '',
			message: '',
			isDirty: false,
			ready: false
		}
	},
	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async show(opts)
		{
			commands.warmUp();

			this.campaignId = opts.campaignId;

			let campaign = await getEmailCampaignView(opts.campaignId)
			this.name = campaign.name;
			this.audience = campaign.audience;
			this.exclusions = campaign.exclusions.join('\n')
			this.subject = campaign.subject;
			this.message = campaign.message
			this.isDirty = false;
			this.ready = true;
		},
		changed() {
			this.isDirty = true;
		},
		async handlePaste(event)
		{
			let clipboard = await pasteHandler(event);
			
			if(clipboard.image)
			{
				showLoading();

				let image = await Promise.resolve(clipboard.image);
				const reader = new FileReader();
				reader.onloadend = async () => {
					let result = await commands.emailCampaigns.uploadImage({ image: reader.result})

					let markdown = `![Alt text](${result.id})`
					this.message = this.message.substring(0, this.$refs.message.selectionStart) + markdown + this.message.substr(this.$refs.message.selectionEnd)

					hideLoading();
				};
				reader.onerror = e => {
					console.error(e);
					hideLoading();
				}
				reader.readAsDataURL(image);
				return;
			}

			if(clipboard.textHtml)
			{
				// TODO: turndown html->markdown?
				this.message = this.message.substring(0, this.$refs.message.selectionStart) + clipboard.textHtml + this.message.substr(this.$refs.message.selectionEnd)
			}
			
			if(clipboard.textPlain)
			{
				this.message = this.message.substring(0, this.$refs.message.selectionStart) + clipboard.textPlain + this.message.substr(this.$refs.message.selectionEnd)
			}

		},
		async submit() {			
			showLoading();

			let exclusions = this.exclusions.split('\n').map(l => l.trim()).filter(l => l.length);

			await commands.emailCampaigns.update({
				id: this.campaignId,
				name: this.name,
				audience: this.audience,
				exclusions: exclusions,
				subject: this.subject,
				message: this.message
			})

			this.isDirty = false;

			navigate('/admin/email-campaigns')

			hideLoading();
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit" @change="changed">
		<div class="row justify-content-center py-5">
			<div class="col-12 col-md-8">
				
				<h1 class="display-4 text-center mb-3">Edit campaign</h1>
				<p class="text-muted text-center mb-5">Author a new community email</p>

				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Campaign details</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group mb-4">
								<label>Name</label>
								<input type="text" class="form-control" v-model="name" autocomplete="off" required />
								<span class="invalid-feedback"></span>
							</div>
							<div class="form-group mb-4">
								<label>Recipients</label>
								<select class="form-control" v-model="audience">
									<option value="all">All registered users</option>
									<option value="active">Active members</option>
									<option value="expiring">Expiring members</option>
									<option value="expired">Expired members</option>
									<option value="council">Council</option>
									<option value="rsos">RSOs</option>
									<option value="l1s">HPR L1s Only</option>
									<option value="l1s+">HPR L1s and Above</option>
									<option value="l2s">HPR L2s Only</option>
									<option value="l2s+">HPR L2s and Above</option>
									<option value="l3s">HPR L3s Only</option>
									<option value="mapa">MAP Assessors</option>
								</select>
								<span class="invalid-feedback"></span>
							</div>
							<div class="form-group mb-0">
								<label>Exclusions</label>
								<textarea class="form-control h-auto" autocomplete="off" rows="5" v-model="exclusions"></textarea>
								<span class="invalid-feedback"></span>
								<p class="form-text text-muted small mb-0">Line separated email addresses of those not to send to.</p>
							</div>
						</fieldset>
					</div>
				</div>

				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Email content</h4>
					</div>
					<div class="card-body">
						<fieldset>
							<div class="form-group mb-4">
								<label>Subject</label>
								<input type="text" class="form-control" v-model="subject" autocomplete="off" required />
								<span class="invalid-feedback"></span>
							</div>
							<div class="form-group mb-0">
								<label>Message</label>
								<textarea class="form-control h-auto" @paste="handlePaste" ref="message" autocomplete="off" rows="25" required v-model="message"></textarea>
								<span class="invalid-feedback"></span>
							</div>
						</fieldset>
					</div>
				</div>
				<button type="submit" class="btn btn-lg btn-primary btn-block">Save campaign <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>
</template>